import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Customer } from '../../../models/customer';
import { CustomerDetailsActivityComponent } from './customer-details-activity-component/customer-details-activity-component';
import { CustomerDetailsGeneralInfoComponent } from './customer-details-general-info-component/customer-details-general-info-component';
import { CustomerDetailsNotesComponent } from './customer-details-notes-component/customer-details-notes-component';
import { AddCreditWalletForm } from '../../../@shared/forms/customers/add-credit-wallet-form/add-credit-wallet-form';
import { AddDebitWalletForm } from '../../../@shared/forms/customers/add-debit-wallet-form/add-debit-wallet-form';
import { CustomerWalletTransactionHistoryList } from './customer-wallet-transaction-history-list/customer-wallet-transaction-history-list';
import { CustomerPaymentTransactionHistoryList } from './customer-payment-transaction-history-list/customer-payment-transaction-history-list';
import { CustomerPointsTransactionHistory } from './customer-points-transaction-history/customer-points-transaction-history';
import { AddCustomerNoteForm } from '../../../@shared/forms/customers/add-customer-note-form/add-customer-note-form';
import { EmployeeService } from '../../../services/employees/employee-service';
import { Employee } from '../../../models/employee';
import { SendNotificationCustomerForm } from '../../../@shared/forms/customers/send-notification-customer-form/send-notification-customer-form';
import { ChargeCustomerCardForm } from '../../../@shared/forms/customers/charge-customer-card-form/charge-customer-card-form';
import { UpdateCustomerForm } from '../../../@shared/forms/customers/update-customer-form/update-customer-form';
import { CommonModule, DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-customer-details',
  imports: [CommonModule, DatePipe, DecimalPipe, TitleCasePipe, RouterLink, CustomerDetailsActivityComponent, CustomerDetailsGeneralInfoComponent, CustomerWalletTransactionHistoryList, CustomerPaymentTransactionHistoryList, CustomerPointsTransactionHistory, CustomerDetailsNotesComponent, AddCreditWalletForm, AddCustomerNoteForm, AddDebitWalletForm, SendNotificationCustomerForm, ChargeCustomerCardForm, UpdateCustomerForm],
  templateUrl: './customer-details.html',
  styleUrl: './customer-details.scss'
})
export class CustomerDetails implements OnInit {

  @ViewChild(CustomerDetailsGeneralInfoComponent) CustomerDetailsGeneralInfo: CustomerDetailsGeneralInfoComponent;
  @ViewChild(CustomerDetailsActivityComponent) CustomerDetailsActivity: CustomerDetailsActivityComponent;
  @ViewChild(CustomerDetailsNotesComponent) CustomerDetailsNotes: CustomerDetailsNotesComponent;
  @ViewChild(CustomerWalletTransactionHistoryList) walletTransactionhistory: CustomerWalletTransactionHistoryList;
  @ViewChild(CustomerPaymentTransactionHistoryList) paymentTransactionhistory: CustomerPaymentTransactionHistoryList;
  @ViewChild(CustomerPointsTransactionHistory) pointsTransactionHistory: CustomerPointsTransactionHistory;

  customerDetails = signal<Customer | null>(null);
  customerID: string
  activeTab = "0";
  addCustomerNoteForm = false
  addCreditWalletForm = false
  addDebitWalletForm = false
  chargeCardForm = false
  deleteCustomerForm = false
  sendNotificationForm = false
  updateCustomerForm = false

  employee = signal<Employee | undefined>(undefined);

  private employeeService = inject(EmployeeService)
  router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)

  ngOnInit() {
    this.getCustomerId()
    this.restoreTabFromUrl()
    this.getEmployee()
  }

  onCustomerLoaded(customer: Customer) {
    this.customerDetails.set(customer);
  }

  navigateToCustomerRides(): void {
    const email = this.customerDetails()?.email;
    if (email) {
      this.router.navigate(['/rides'], { queryParams: { search: email } });
    }
  }

  get customerRidesLink(): string {
    const email = this.customerDetails()?.email;
    return email ? `/rides?search=${encodeURIComponent(email)}` : '/rides';
  }

  onRidesCardClick(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey) {
      window.open(this.customerRidesLink, '_blank');
      return;
    }
    this.navigateToCustomerRides();
  }

  getCustomerId = () => {
    this.activatedRoute.paramMap.subscribe(params => {
      this.customerID = params.get('id')!;
    });
  }

  getEmployee = () => {
    this.employee = this.employeeService.employee;
  }

restoreTabFromUrl = () => {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const tab = params.get('tab');
      this.activeTab = tab ?? '0';
    });
  }

  // onTabChange = (tab: string | number | undefined) => {
  //   const tabValue = String(tab);
  //   this.activeTab.set(String(tab));
  //   this.router.navigate([], {
  //     relativeTo: this.activatedRoute,
  //     queryParams: { tab: tabValue },
  //     queryParamsHandling: ''
  //   });
  //   this.buildSplitButtonItems();

  //   // if (this.activeTab() === '0') {
  //   //   this.CustomerDetailsGeneralInfo.getCustomerDetails()
  //   // } else if (this.activeTab() === '1') {
  //   //   this.CustomerDetailsActivity.getCustomerActivityList()
  //   // } else if (this.activeTab() === '2') {
  //   //   this.CustomerDetailsNotes.getCustomerNotesList()
  //   // } else if (this.activeTab() === '3') {
  //   //   this.walletTransactionhistory?.getWalletTransactionsList();
  //   // } else if (this.activeTab() === '4') {
  //   //   this.paymentTransactionhistory?.getPaymentTransactionsList();
  //   // } else if (this.activeTab() === '5') {
  //   //   this.pointsTransactionHistory?.getPointTransactionsList();
  //   // }

  //   this.CustomerDetailsNotes?.resetAll(this.activeTab());
  //   this.walletTransactionhistory?.resetAll(this.activeTab());
  //   this.CustomerDetailsActivity?.resetAll(this.activeTab());
  //   this.paymentTransactionhistory?.resetAll(this.activeTab());
  //   this.pointsTransactionHistory?.resetAll(this.activeTab());
  // }

  //   onTabChange = (tab: string | number | undefined) => {
  //   const tabValue = String(tab);
  //   this.activeTab = tabValue;

  //   this.router.navigate([], {
  //     relativeTo: this.activatedRoute,
  //     queryParams: { tab: tabValue },
  //     queryParamsHandling: ''
      
  //   }).then(() => {
  //     this.buildSplitButtonItems()
  //     this.CustomerDetailsNotes?.resetAll(tabValue);
  //     this.walletTransactionhistory?.resetAll(tabValue);
  //     this.CustomerDetailsActivity?.resetAll(tabValue);
  //     this.paymentTransactionhistory?.resetAll(tabValue);
  //     this.pointsTransactionHistory?.resetAll(tabValue);
  //   });
  // }

  onTabChange = (tab: string | number | undefined) => {
  const tabValue = String(tab);
  this.activeTab = tabValue;

  this.router.navigate([], {
    relativeTo: this.activatedRoute,
    queryParams: { tab: tabValue },
    queryParamsHandling: ''
  }).then(() => {
    // ✅ NO navigation inside these
    this.CustomerDetailsNotes?.resetAll();
    this.walletTransactionhistory?.resetAll();
    this.CustomerDetailsActivity?.resetAll();
    this.paymentTransactionhistory?.resetAll();
    this.pointsTransactionHistory?.resetAll();
  });
}

  openAddCreditWalletForm = () => {
    this.addCreditWalletForm = true
  }

  onCreditWalletAdded = () => {
    this.CustomerDetailsGeneralInfo.getCustomerDetails()
    this.addCreditWalletForm = false
  }

  openAddDebitWalletForm = () => {
    this.addDebitWalletForm = true
  }

  onDebitWalletAdded = () => {
    this.CustomerDetailsGeneralInfo.getCustomerDetails()
    this.addDebitWalletForm = false
  }

  openChargeCardForm = () => {
    this.chargeCardForm = true
  }

  oncardCharged = () => {
    this.CustomerDetailsGeneralInfo.getCustomerDetails()
    this.chargeCardForm = false
  }

  openDeleteCustomerForm = () => {
    this.deleteCustomerForm = true
  }

  openAddCustomerNoteForm = () => {
    this.addCustomerNoteForm = true
  }

  onCustomerNoteAdded = () => {
    this.CustomerDetailsNotes.refreshList()
    this.addCustomerNoteForm = false
  }

  openSendNotificationForm = () => {
    this.sendNotificationForm = true
  }

  onNotificationSent = () => {
    this.sendNotificationForm = false
  }

  openUpdateCustomerForm = () => {
    this.updateCustomerForm = true
  }

  onCustomerUpdated = () => {
    this.CustomerDetailsGeneralInfo.getCustomerDetails()
    this.updateCustomerForm = false
  }

}
